import styled from 'styled-components'

export const PageHeader = styled.div`
    padding: 32px;
    border-bottom: 1px solid ${(props)=> props.theme.PrimaryBorderColor};
    min-height: 32px;
`; 